<template>
  <nav
    v-if="breadcrumbs.length"
    v-bind="$attrs"
    aria-label="breadcrumb"
    class="flex space-3 rounded-lg"
  >
    <ol
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
      class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse"
    >
      <li
        v-for="(breadcrumb, i) in breadcrumbs"
        :key="breadcrumb.text"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
        :aria-current="breadcrumbLast(breadcrumbs) === i && 'page'"
        class="inline-flex items-center"
      >
        <template v-if="breadcrumbLast(breadcrumbs) !== i">
          <!-- Breadcrumbs Schema's first item has no attributes other than itemProp in the anchor -->
          <slot v-bind="{ breadcrumb }" name="link">
            <NuxtLink
              :data-testid="breadcrumb.text"
              :to="breadcrumb.link"
              class="no-underline inline-flex items-center text-xs font-normal text-gray-700 hover:underline"
              :itemprop="'item'"
              :itemscope="true"
              :itemtype="'https://schema.org/WebPage'"
              :itemid="breadcrumb.link"
            >
              <span itemprop="name">{{ breadcrumb.text }}</span>
            </NuxtLink>
            <meta itemprop="position" :content="i + 1" />
            <div
              v-if="i + 1 < breadcrumbs.length"
              class="m-3 block w-1 h-1 rounded-full bg-gray-400"
            />
          </slot>
        </template>
        <template v-else>
          <!-- @slot Custom markup for current page (binds `breadcrumb` object) -->
          <slot v-bind="{ breadcrumb }" name="current">
            <div
              class="no-underline inline-flex items-center text-xs font-normal text-gray-400 cursor-default"
            >
              <span itemprop="name">{{ breadcrumb.text }}</span>
              <meta itemprop="position" :content="i + 1" />
            </div>
          </slot>
        </template>
      </li>
    </ol>
  </nav>
</template>

<script lang="ts" setup>
import type { Breadcrumb } from '~/composables/useEventBreadcrumbs'

withDefaults(
  defineProps<{
    breadcrumbs: { text: string; link: string }[]
  }>(),
  { breadcrumbs: () => [] }
)

const breadcrumbLast = (breadcrumbs: Breadcrumb[]) => {
  return breadcrumbs.length - 1
}
</script>
